(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxObjectRating', {
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-object-rating/mx-object-rating.html',
		controller: MxObjectRatingCtrl,
		controllerAs: 'vm',
		bindings: {
			value: '=?',
			count: '=?',
			max: '@',
			readOnly: '=?',
			disabled: '=?',
			label: '@',
			objectId: '=?',
			entityType: '@',
			showSummary: '@',
		},
	});

	MxObjectRatingCtrl.$inject = ['mx.SolutionBuilderAgent.Http', 'mx.internationalization'];

	function MxObjectRatingCtrl(http, i18n) {
		var vm = this;
		vm.i18n = i18n.get('solutionBuilderAgent.components.mx-object-rating');

		vm.$onInit = function () {
			vm.onRateChange = onRateChange;
			vm.submitRating = submitRating;
			vm.cancelRating = cancelRating;
			updateSummary();

			vm.defaultRate = vm.value || 0;

			if (!vm.readOnly) {
				isRated().then(function (result) {
					if (result === true) {
						vm.readOnly = true;
					}
				});
			}
		};

		function onRateChange(value) {
			vm.showComment = true;
			vm.value = value;
		}

		function updateSummary() {
			var value = parseFloat(vm.value || 0).toFixed(2);
			var count = vm.count || 0;

			vm.summary = value + ' (' + count + ' ' + vm.i18n.ratings + ')';
			vm.ariaSummary = i18n.getFormatted('solutionBuilderAgent.components.mx-object-rating.ARIA-votesAmount', count);
		}

		function isRated() {
			return http.get('api/rating/isRated', {
				id: vm.objectId,
			});
		}

		function submitRating() {
			http.post('api/rating/rate', {
				id: vm.objectId,
				entityType: vm.entityType,
				comments: vm.comments,
				rate: vm.value,
			}).then(function (result) {
				vm.count = result.Count;
				vm.value = result.Average;
				updateSummary();

				vm.readOnly = true;
				vm.showComment = false;
				vm.comments = '';
			});
		}

		function cancelRating() {
			vm.showComment = false;
			vm.comments = '';
			vm.value = vm.defaultRate;
		}

		return vm;
	}
})();
